import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

const ConfirmModal1 = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  description,
  confirmText = "Delete",
  cancelText = "Cancel",
  confirmColor = "danger"
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      toggle={onClose}
      centered
      style={{ zIndex: 1060 }}
      backdrop="static"
    >
      <ModalHeader toggle={onClose}>
        {title || "Are you sure?"}
      </ModalHeader>
      <ModalBody>
        <p className="mb-0">
          {description || "This action cannot be undone."}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="secondary" 
          onClick={onClose}
          className="cancel_Btn"
        >
          {cancelText}
        </Button>
        <Button 
          className="btn btn-primary"
          // color={confirmColor}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal1;
